import api from "../api";
import { addCartItemRequest, addCartItemSuccess } from "../slices/CartSlice"

export const addCart = (id,quantity)=>async(dispatch)=>{
    try{
        dispatch(addCartItemRequest());
        const { data } = await api.get(`/product/${id}`);
        dispatch(addCartItemSuccess({
            product: data.product._id,
            name: data.product.name,
            price: data.product.price,
            image: data.product.images[0].image,
            stock: data.product.stock,
            quantity
        }));
    }
    catch(error){
         console.error("Error adding to cart:", error);
    }
}